import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/sagas.js